<template>
  <div>
    <!-- 角色创建编辑窗口 -->
    <el-dialog
      :title="diaTitle"
      :visible="true"
      width="990px"
      @close="closeDia"
    >
      <el-form
        :model="roleForm"
        :rules="rules"
        ref="roleForm"
        label-width="120px"
      >
        <el-form-item label="权限组名称" prop="roleName" style="margin-bottom: 18px">
          <el-input
            size="medium"
            maxLength="15"
            v-model="roleForm.roleName"
            :readonly="diaTitle === '权限组详情' || diaTitle === '查看权限组'"
            placeholder="请输入权限组名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="权限组描述" prop="remark" style="margin-bottom: 18px">
          <el-input
            type="textarea"
            :autosize="{ minRows: 1, maxRows: 3 }"
            v-model="roleForm.remark"
            :readonly="diaTitle === '权限组详情' || diaTitle === '查看权限组'"
            placeholder="请输入权限组描述，100字以内"
          ></el-input>
        </el-form-item>
        <el-form-item label="权限组权限" prop="perms">
          <div class="grant-box" v-if="grant">
            <el-tree
              ref="permsAuthListRef"
              show-checkbox
              node-key="pid"
              default-expand-all
              :expand-on-click-node="false"
              :data="!viewDetail ? juris : newJuris"
              :props="props"
              :default-checked-keys="defaultCheckedKeys"
              @check="checkNode"
              @check-change="handleCheckChange"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <span v-if="data.tips">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="data.tips"
                    placement="right"
                  >
                    <i
                      style="width: 12px; height: 12px; margin-left: 5px"
                      class="icon-w1"
                    ></i>
                  </el-tooltip>
                </span>
              </span>
            </el-tree>
          </div>
        </el-form-item>
        <el-form-item v-if="organization">
          <template slot="label">
            可授权权限组
            <el-tooltip
              class="item"
              effect="dark"
              content="当拥有组织架构管理权限时，可以将以下选中的权限组授权给指定的成员使用"
              placement="right"
            >
              <i
                style="width: 12px; height: 12px; margin-left: 5px"
                class="icon-w1"
              ></i>
            </el-tooltip>
          </template>
          <!-- 选中组织架构管理才显示 -->
          <div class="group">
            <div class="checkbox">
              <!--              <span style="margin-right:10px"></span>-->
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                :disabled="viewDetail"
                @change="handleCheckAllChange"
                >全选</el-checkbox
              >
              <el-checkbox-group v-model="roles" @change="checkedChange" style="margin-left: 18px">
                <el-checkbox
                  v-for="role of distributeRoles"
                  :label="role.corpRoleId"
                  :key="role.corpRoleId"
                  :disabled="viewDetail"
                  >{{ role.roleName }}</el-checkbox
                ><br />
              </el-checkbox-group>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="diaTitle == '角色详情'"
          size="mini"
          type="primary"
          @click="closeDia"
          >关 闭</el-button
        >
        <div v-else-if="!viewDetail">
          <el-button size="mini" @click="roleRest">重 设</el-button>
          <el-button
            size="mini"
            type="primary"
            :loading="submitLod"
            @click="roleSubmit"
            >提 交</el-button
          >
        </div>
      </span>
    </el-dialog>
    <!-- 角色创建编辑窗口 end -->
  </div>
</template>

<script>
// 接口
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
// 数据
import { juris } from "../../../../assets/js/utils/jurisdiction";
export default {
  props: {
    diaTitle: { type: String, default: "创建权限组" },
    rowInfo: { type: Object, default: () => { } },
    distributeRoles: { type: Array, default: () => [] },
    viewDetail: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      newJuris: [],
      grant: true,
      roles: [],
      defaultCheckedKeys: [], // 修改或者查看时回显
      submitLod: false,
      juris,
      props: {
        label: "name",
        children: "children"
      },
      organization: false,
      isIndeterminate: true,
      checkAll: false,
      halfCheckedKeys: [], // 半选中的数据（选中了部分子集的情况）
      roleForm: { roleName: "", remark: "", perms: [], rolesJson: [] },
      rules: {
        roleName: [
          { required: true, message: "请输入权限组名称", trigger: "blur" }
        ],
        remark: [
          { required: true, message: "请输入权限组描述", trigger: "blur" }
        ],
        perms: [{ required: true, message: "请选择权限", trigger: "blur" }]
      }
    };
  }, // data end
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.newJuris = this.recursionFn(JSON.parse(JSON.stringify(this.juris)));
    },
    recursionFn(arr) {
      return arr.map((item) => {
        item.disabled = true;
        if (item.children) {
          this.recursionFn(item.children);
        }
        return item
      })
    },
    // 重设角色
    async roleRest () {
      this.closeDia(false);
      setTimeout(() => {
        this.grant = true;
      }, 300);
    },
    // 提交角色创建
    roleSubmit () {
      this.$refs.roleForm.validate(vaild => {
        if (vaild) {
          this.submitLod = true;
          let { roleName, remark, perms, corpRoleId } = this.roleForm,
            rolesArr = [];
          // let param = JSON.parse(JSON.stringify(this.roleForm)),
          // 若勾选了组织架构就便利出数据
          if (this.organization) {
            this.distributeRoles.forEach(elem => {
              rolesArr.push({
                corpRoleId: elem.corpRoleId,
                operType: this.roles.indexOf(elem.corpRoleId) > -1 ? 1 : 0
              });
            });
          }
          // 将半选中的数据也需要加入到权限里
          let permsCopy = JSON.parse(JSON.stringify(perms));
          let permsJson =
            this.halfCheckedKeys.length > 0
              ? permsCopy.concat(this.halfCheckedKeys)
              : permsCopy;
          // 若是修改。接口数据返回的数据中包含9，后端说不影响，但是接口不通。所以过滤出去
          let permsNew = permsJson.filter(item => {
            return item != 9 && item != 99801;
          });
          // 创建参数
          let param = {
            roleName,
            remark,
            rolesJson: JSON.stringify(rolesArr),
            perms: permsNew.join(),
            allRole: this.checkAll ? 1 : 0,
            sealsJson: JSON.stringify([])
          };
          if (corpRoleId) param.corpRoleId = corpRoleId;
          ApiCorpMethods.RoleController.operRole(param).then(res => {
            if (res.success) {
              this.$message({
                message: this.diaTitle === '创建权限组' ? '创建成功，重新登录后生效' : '修改成功，重新登录后生效',
                type: "success"
              });
              // 刷新角色数据
              this.$emit("getRoles");
              // 关闭窗口
              this.closeDia();
            } else {
              this.submitLod = false;
              this.$message.error(res.description);
            }
          });
        }
      });
    },
    checkNode (node, checkInfo) {
      let { checkedKeys, halfCheckedKeys } = checkInfo;
      (this.roleForm.perms = checkedKeys),
        (this.halfCheckedKeys = halfCheckedKeys);
    },
    handleCheckChange (data, checked, indeterminate) {
      // let perms = this.roleForm.perms;
      // data.checked = checked;
      if (data.pid == 101) {
        this.organization = checked;
        this.roleForm.rolesJson = [];
        this.isIndeterminate = false;
      } else if (data.pid === 10401 && checked === true) {
        this.$refs.permsAuthListRef.setChecked(104, true)
      } else if (data.pid === 10601 && checked === true) {
        this.$refs.permsAuthListRef.setChecked(106, true)
      } else if (data.pid === 104 && checked === false) {
        this.$refs.permsAuthListRef.setChecked(10401, false)
      } else if (data.pid === 106 && checked === false) {
        this.$refs.permsAuthListRef.setChecked(10601, false)
      }
    },
    checkedAll () {
      let all = [];
      this.distributeRoles.forEach(elem => {
        all.push(elem.corpRoleId);
      });
      return all;
    },
    // 选择所有角色
    async handleCheckAllChange (val) {
      this.roles = val ? await this.checkedAll() : [];
      this.isIndeterminate = false;
    },
    // 选择某个角色
    checkedChange (value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.distributeRoles.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.distributeRoles.length;
    },
    /**
     * 关闭窗口之前，重置数据
     * @param close 是否关闭窗口
     */
    closeDia (close = true) {
      this.$refs.roleForm.resetFields();
      // this.roleForm = { roleName: "", remark: "", perms: [], rolesJson: [] };
      this.roleForm.roleName = "";
      this.roleForm.remark = "";
      this.roleForm.perms = [];
      this.roleForm.rolesJson = [];
      this.defaultCheckedKeys = [];
      this.halfCheckedKeys = [];
      this.grant = false;
      this.roles = [];
      this.checkAll = false;
      this.organization = false;
      // this.$emit("update:dialogVisi", false);
      if (close) this.$emit("closePup");
    },
    async echo () {
      // this.rowInfo 有数据就是编辑或者查看需要赋值回显
      let row = this.rowInfo;
      let haveRow = Object.keys(row);
      if (haveRow.length > 0) {
        let { perms, allRole, corpRoleId } = row;
        // 获取可授权角色数据
        let roleRes = await ApiCorpMethods.RoleController.detailAssignRoles({
          corpRoleId,
          pageSize: 10000
        });
        this.grant = true;
        this.roleForm = JSON.parse(JSON.stringify(row));
        // perms 需要将里面的父级权限剥离出去，否者修改时回显不是想要的效果
        let newPerms = perms.filter(item => {
          return [4, 6, 3, 12].indexOf(item) == -1;
        });
        this.defaultCheckedKeys = newPerms;
        // 如果有组织架构权限需要打开角色多选框
        this.organization = perms.includes(101);
        if (allRole == 1) {
          // 全选
          this.checkAll = true;
          this.roles = this.checkedAll();
        } else {
          // 非全选
          this.roles = [];
          roleRes.data.forEach(elem => {
            if (elem.assigned == 1) this.roles.push(elem.corpRoleId);
          });
        }
      }
    }
  }, // methods end
  beforeMount () {
    this.echo();
  }
};
</script>
<style lang="less" scoped>
  /deep/ .el-form-item__label {
    line-height: 26px;
  }
  /*tree样式定制*/
  /deep/ .el-tree-node__expand-icon.expanded {
    display: none;
  }
  /deep/ .el-tree-node__expand-icon.is-leaf {
    display: none;
  }
/deep/ .el-tree-node__content {
  margin-bottom: 5px;
}
/deep/ .el-tree-node__children {
  display: flex !important;
  flex-wrap: wrap;
  .el-tree-node__content {
    width: 200px;
    overflow: hidden;
    margin-bottom: 5px;
  }
}
  /**el-checkbox定制***/
  /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #ec1c1e;
    border-color: #ec1c1c;
  }
  /deep/ .el-checkbox__input.is-disabled.is-indeterminate .el-checkbox__inner {
    background-color: #ec1c1e;
    border-color: #ec1c1c;
  }
  /deep/ .el-checkbox__input.is-disabled+span.el-checkbox__label {
    color: #606266;
  }
  /deep/ .el-form-item__content {
    line-height: 30px;
  }
.group {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .checkbox /deep/ .el-checkbox {
    margin-right: 0;
  }
  .checkbox /deep/ .el-checkbox__label {
    width: 176px;
    display: -ms-inline-grid;
    display: -moz-inline-grid;
    display: inline-grid;
    /*width: 240px;*/
    /*white-space: pre-line;*/
    word-wrap: break-word;
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// components/console/memberManage/components/rloeFormNew.vue